import styled, { css } from 'styled-components';
import { atomicBlockContainerWidth, borderRadius, colorUsage, fontSize, fontWeight, getSpacing, imagePreviewHeight } from 'stylesheet';
var LoaderContainer = styled.div.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__LoaderContainer",
  componentId: "sc-1nu5slr-0"
})(["display:flex;justify-content:center;width:", ";height:140px;margin:", ";"], atomicBlockContainerWidth, getSpacing(1));
var AffiliationPriceTable = styled.div.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTable",
  componentId: "sc-1nu5slr-1"
})(["display:flex;flex-direction:column;flex-wrap:wrap;justify-content:left;row-gap:", ";"], getSpacing(1));
var AffiliationPriceTableImageContainer = styled.div.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableImageContainer",
  componentId: "sc-1nu5slr-2"
})(["position:relative;margin:auto;", " overflow:hidden;border-radius:", ";"], function (_ref) {
  var isBroken = _ref.isBroken;
  return isBroken ? css(["border:1px solid ", ";"], colorUsage.message.warning) : css(["border:1px solid ", ";"], colorUsage.imageBorder);
}, borderRadius.medium);
var AffiliationPriceTableImage = styled.img.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableImage",
  componentId: "sc-1nu5slr-3"
})(["display:block;width:fit-content;max-width:100%;max-height:", ";margin:auto;object-fit:contain;"], imagePreviewHeight);
var AffiliationPriceTableOffersContainer = styled.div.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableOffersContainer",
  componentId: "sc-1nu5slr-4"
})(["padding:", ";border:1px solid ", ";border-radius:", ";"], getSpacing(1), colorUsage.affiliation, borderRadius.medium);
var AffiliationPriceTableOffers = styled.table.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableOffers",
  componentId: "sc-1nu5slr-5"
})(["width:100%;"]);
var AffiliationPriceTableOffer = styled.tr.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableOffer",
  componentId: "sc-1nu5slr-6"
})(["font-size:", ";"], fontSize.normal);
var AffiliationPriceTableOfferRetailer = styled.td.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableOfferRetailer",
  componentId: "sc-1nu5slr-7"
})([""]);
var AffiliationPriceTableOfferPrice = styled.td.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableOfferPrice",
  componentId: "sc-1nu5slr-8"
})(["color:", ";text-align:right;"], colorUsage.affiliation);
var AffiliationPriceTableTitle = styled.span.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableTitle",
  componentId: "sc-1nu5slr-9"
})(["display:block;font-weight:", ";font-size:", ";"], fontWeight.bold, fontSize.large);
var AffiliationPriceTableWarning = styled.span.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__AffiliationPriceTableWarning",
  componentId: "sc-1nu5slr-10"
})(["position:absolute;top:", ";right:5px;"], getSpacing(1));
var NoOffer = styled.span.withConfig({
  displayName: "AffiliationBlockPriceTablestyle__NoOffer",
  componentId: "sc-1nu5slr-11"
})(["color:", ";"], colorUsage.message.warning);
export { AffiliationPriceTable, AffiliationPriceTableImage, AffiliationPriceTableImageContainer, AffiliationPriceTableOffer, AffiliationPriceTableOfferPrice, AffiliationPriceTableOfferRetailer, AffiliationPriceTableOffers, AffiliationPriceTableOffersContainer, AffiliationPriceTableTitle, AffiliationPriceTableWarning, LoaderContainer, NoOffer };